const robotInfo = {
  state: {
    show_win: false,
  },
  mutations: {
    SHOW_WIN: state => {
      console.log(state, '7777')
      state.show_win = !state.show_win
    },
  },
  actions: {
    init_robotinfo: ({ commit }) => {
      commit('SHOW_WIN')
    },
  }
}

export default robotInfo



// WEBPACK FOOTER //
// ./src/store/modules/robot.js